import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Users/hooks/useUserNames.ts
function useUserNames(args, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Users.GetUserNames.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.userIds && fire
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useUserNames };

//# sourceMappingURL=useUserNames.js.map